module.exports = __webpack_public_path__ + "static/media/7_l_bordur_0_96.2.abe7dff2.png";